export default __webpack_public_path__ + "static/Patron-57ce36b77ba5a59bd9a8c71e4a95fbb1.png";